import pharmacy from 'services/pharmacy';

export default () => {
  return (ODSCode) => pharmacy.get(`/pharmacies/odscode/${ODSCode}`);
};
